import { yyyy, zzzz } from "../store.svelte"
import { toast } from "../lib/toast.svelte.ts"
import signOut from "./signOut.svelte"

const url: string = yyyy.uri.api;

let getlivewires = async () => {
	if (!yyyy.sesh.logtoken) {
		return false;
	}
	let _hdrs = {
		"Content-Type": "application/json",
		Authorization: "Bearer " + yyyy.sesh.logtoken.token,
	};
	
	// Always check the store for sort order
	const currentSort = yyyy.livewire_sortorder || 'default';
	
	// Determine the order parameter based on currentSort
	let orderParam = 'ispinned.desc,created_at'; // default
	switch (currentSort) {
		case 'a-z':
			orderParam = 'ispinned.desc,livewire.asc';
			break;
		case 'z-a':
			orderParam = 'ispinned.desc,livewire.desc';
			break;
		case 'newest':
			orderParam = 'ispinned.desc,created_at.desc';
			break;
		case 'oldest':
			orderParam = 'ispinned.desc,created_at.asc';
			break;
		default:
			orderParam = 'ispinned.desc,created_at';
			break;
	}
	
	let fetchopts = { method: "get", headers: _hdrs };
	const response = await fetch(
		`${url}/livewires?select=*,propagate(sharee),chronicle!predecessor(livewire_id)&isready=not.is.null&order=${orderParam}`,
		fetchopts,
	);
	if (response.ok) {
		yyyy.livewires = await response.json();
	}
	if (!response.ok) {
		toast.error("Your session has expired.");
		signOut();
	}
	// yyyy.sesh.activeLivewire = {
	// 	wireident: wireident,
	// 	livewire: livewire,
	// 	extent: g,
	// };
	// zzzz.emit("map-active");



}

export default getlivewires
